import { useEffect, useState } from "react";
import { api, INR } from "@/lib/api";
import { Users, Inbox, CheckCircle2, TrendingUp, IndianRupee, Clock } from "lucide-react";

export default function AdminOverview() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/admin/stats").then(({data}) => setS(data)); }, []);
  if (!s) return <div className="p-16 text-center text-black/40">Loading stats...</div>;
  const kpis = [
    { icon: Inbox, label: "Total leads", v: s.total_leads },
    { icon: Clock, label: "New leads", v: s.new_leads },
    { icon: CheckCircle2, label: "Approved", v: s.approved },
    { icon: TrendingUp, label: "Disbursed", v: s.disbursed },
    { icon: Users, label: "Customers", v: s.customers },
    { icon: IndianRupee, label: "Disbursed amount", v: INR(s.disbursed_amount) },
  ];
  return (
    <div className="p-8 lg:p-12" data-testid="admin-overview">
      <h1 className="font-display text-3xl">Overview</h1>
      <p className="text-black/50 mt-1">Real-time snapshot of your loan business.</p>

      <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-4 mt-8">
        {kpis.map((k,i) => (
          <div key={i} className="bg-white border border-[#EAEAEA] rounded-xl p-5" data-testid={`kpi-${k.label.toLowerCase().replace(/\s+/g,"-")}`}>
            <k.icon size={18} className="text-[#B08A18]"/>
            <div className="text-[11px] uppercase tracking-widest text-black/50 mt-3">{k.label}</div>
            <div className="text-2xl font-display text-black mt-1 truncate">{k.v}</div>
          </div>
        ))}
      </div>

      <div className="grid lg:grid-cols-3 gap-6 mt-10">
        <div className="lg:col-span-2 bg-white border border-[#EAEAEA] rounded-xl p-6">
          <div className="flex items-center justify-between mb-4">
            <h2 className="font-display text-xl">Recent leads</h2>
            <span className="text-xs text-black/50">Last {s.recent_leads.length}</span>
          </div>
          <table className="w-full text-sm sk-table">
            <thead>
              <tr className="text-left text-xs uppercase tracking-widest text-black/50">
                <th className="py-3">Name</th><th>Loan</th><th>Amount</th><th>Status</th>
              </tr>
            </thead>
            <tbody>
              {s.recent_leads.map(l => (
                <tr key={l.id} className="border-t border-[#EEE]">
                  <td className="py-3">
                    <div className="font-medium">{l.name}</div>
                    <div className="text-xs text-black/40">{l.phone}</div>
                  </td>
                  <td>{l.loan_type}</td>
                  <td>{INR(l.amount)}</td>
                  <td><StatusBadge s={l.status}/></td>
                </tr>
              ))}
              {s.recent_leads.length===0 && <tr><td colSpan="4" className="py-8 text-center text-black/40">No leads yet</td></tr>}
            </tbody>
          </table>
        </div>
        <div className="bg-white border border-[#EAEAEA] rounded-xl p-6">
          <h2 className="font-display text-xl mb-4">By loan type</h2>
          <div className="space-y-3">
            {s.by_loan_type.map((t,i) => (
              <div key={i}>
                <div className="flex justify-between text-sm"><span className="font-medium">{t._id}</span><span className="text-black/60">{t.count}</span></div>
                <div className="h-2 bg-black/5 rounded-full mt-1 overflow-hidden">
                  <div className="h-full bg-[#D4AF37]" style={{width:`${(t.count/Math.max(...s.by_loan_type.map(x=>x.count)))*100}%`}}/>
                </div>
              </div>
            ))}
            {s.by_loan_type.length===0 && <div className="text-black/40 text-sm">No data yet</div>}
          </div>
        </div>
      </div>
    </div>
  );
}
export function StatusBadge({ s }) {
  const map = {
    "New": "bg-blue-100 text-blue-800",
    "Contacted": "bg-yellow-100 text-yellow-800",
    "In Review": "bg-purple-100 text-purple-800",
    "Approved": "bg-emerald-100 text-emerald-800",
    "Disbursed": "bg-[#D4AF37]/20 text-[#8A6E1E]",
    "Rejected": "bg-red-100 text-red-800",
  };
  return <span className={`sk-badge ${map[s] || "bg-black/10 text-black/70"}`}>{s}</span>;
}
